module.exports = __webpack_public_path__ + "img/InterviewingIcon.0f68b625.svg";